// stores/useUiState.ts or .js
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUiState = defineStore('ui', () => {
  const showNotes = ref(false)
  const showLogin = ref(false)

  const closeAll = () => {
    showNotes.value = false
    showLogin.value = false
  }

  return { showNotes, showLogin, closeAll }
})
